<template>
<div id="webGl">
  <!-- <canvas v-on:dblclick="cycleStyles()" id="glcanvas"></canvas> -->
  <canvas v-on:dblclick="cycleStyles()" id="glcanvas" width="100vw" height="100vh"></canvas>
</div>
</template>

<script>
export default {
  name: 'webGl',
  data() {
    return {
      patchIsInitialized: false,
      patchIsLoaded: false,
      muted: true
      // loading: 0
    }
  },
  // props: ['startRender'],
  methods: {
    // test() {
    //   alert("w2")
    // },
    cycleStyles() {
      this.$root.$emit('cycleStyles')
    },
    showError(errId, errMsg) {
      alert('An error occured: ' + errId + ', ' + errMsg);
    },
    patchInitialized() {
      this._changeStyle = CABLES.patch.getVar("UI_changeStyle")
      this._changeStyle.setValue(1)

      this._loadingStatus = CABLES.patch.getVar("UI_loadingstatus")

      this._deform = CABLES.patch.getVar("UI_deform")
      this._twist = CABLES.patch.getVar("UI_twist")
      this._inflate = CABLES.patch.getVar("UI_inflate")


      this._mute = CABLES.patch.getVar("UI_mute")
      this._soundtrackSwitch = CABLES.patch.getVar("UI_ENABLE_SOUNDTRACK_SWITCHING")


      this._loadingStatus.addListener((newValue) => {
        this.$root.$emit('preLoadStatus', newValue * 100)
      });


      this.$root.$on('experimentStrength', (val, exp) => {
        if (val == 0) {
          this._deform.setValue(0)
          this._twist.setValue(0)
          this._inflate.setValue(0)
        }
        if (exp == 'COMFORT') this._deform.setValue(val)
        if (exp == 'FLEX') this._twist.setValue(val)
        if (exp == 'CUSHIONING') this._inflate.setValue(val)
      })

      this.$root.$on('changeStyle', (index) => {
        this._changeStyle.setValue(index)
      })

      this.$root.$on('muteSounds2', () => {
        // console.log(this._mute.);
        // this._mute.setValue(bool)
        CABLES.patch.config.UI_audioContext()
        // this.$root.$emit('muteSoundsDisplay', bool)
      })


      this.$root.$on('muteSounds', (bool) => {
        this._mute.setValue(bool)
      })

      // this.$root.$on('changeStyle', (index) => {
      //   this._changeStyle.setValue(index)
      // })

      CABLES.patch.config.openPopup = ([v1]) => {
        this.$root.$emit('openPopup', v1)
      }

      // this._changeStyle.setValue(1)
      this.patchIsInitialized = true

    },
    patchFinishedLoading() {

      new Hammer.Tap({
        event: 'doubletap',
        taps: 2
      })
      new Hammer(document.getElementById('glcanvas')).on('doubletap', () => {
        this.$root.$emit('cycleStyles')
      })
      this.$emit('cablesLoaded', true)
      // this._changeStyle.setValue(1)

      // this.startRender();
      this.patchIsLoaded = true
    },
    startRender() {
      this.$options.canvas.style.pointerEvents = 'auto'

      // CABLES.patch.config.uiShoeLoadedCallback = function(a) {
      //   alert("aa")
      // }
      var self = this;
      var isChrome;
      var isChromium = window.chrome,
        winNav = window.navigator,
        vendorName = winNav.vendor,
        isOpera = winNav.userAgent.indexOf("OPR") > -1,
        isIEedge = winNav.userAgent.indexOf("Edge") > -1,
        isIOSChrome = winNav.userAgent.match("CriOS");

      if (isIOSChrome || (isChromium !== null && isChromium !== undefined && vendorName === "Google Inc." && isOpera === false && isIEedge === false)) {
        // is Google Chrome
        isChrome = true
      }
      this.$nextTick(() => {
        if (isChrome) {

          CABLES.patch.config.uiShoeLoadedCallback = () => {
            // alert("sss")
            self._changeStyle.setValue(2)
            self._soundtrackSwitch.setValue(true)
          }
        } else {

          // setTimeout(function() {
          self._changeStyle.setValue(2)
          self._soundtrackSwitch.setValue(true)
          // }, 2000)
        }
      })
      //
      // setTimeout(function() {
      //   self._changeStyle.setValue(2)
      //   self._soundtrackSwitch.setValue(true)
      // }, 2000)

    }
  },

  mounted() {
    this.$options.canvas = document.getElementById('glcanvas');
    this.$options.canvas.addEventListener('webglcontextlost', function() {});
    this.$options.canvas.addEventListener('webglcontextrestored', function() {});

    var self = this;
    CABLES.patch = new CABLES.Patch({
      patchFile: 'js/My_new_Project.json',
      prefixAssetPath: process.env.NODE_ENV === 'production' ?
        '/assets/experience/am720/' : '/',
      glCanvasId: 'glcanvas',
      glCanvasResizeToWindow: true,
      onError: self.showError,
      onPatchLoaded: self.patchInitialized,
      onFinishedLoading: self.patchFinishedLoading,
      silent: true,
      // uiShoeLoadedCallback: function() {
      //   alert("loaded!")
      // }
      // canvas: {
      //   powerPreference: "high-performance"
      // }
    });

    function preventBehavior(e) {
      e.preventDefault();
    }

    this.$options.canvas.addEventListener('touchmove', preventBehavior, false);



    this.$root.$on('startRender', () => {
      this.startRender()
    })



  },

}
</script>

<style lang="scss">
#webGl {
    // display: none;
    position: fixed;
    bottom: 0;
    margin: 0;
    left: 0;
    height: 100%;
    width: 100%;
    overflow: hidden;
    line-height: 0;
    z-index: 1;
    // -webkit-backface-visibility: hidden;
    // -webkit-transform: translate3d(0,0,0);
    // pointer-events: none;
    canvas {
        height: 100%;
        width: 100%;
        // pointer-events: none;
        pointer-events: auto;
    }
    .sidebar-cables {
        pointer-events: auto;
        display: none;
    }
}
</style>
